import { render, staticRenderFns } from "./AdvertiserCustomer.vue?vue&type=template&id=5bec849a"
import script from "./AdvertiserCustomer.vue?vue&type=script&lang=js"
export * from "./AdvertiserCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports